export const STORAGE_KEYS = {
  PROMPT_RESPONSE: 'promptResponse',
  USER_CONFIGURATION: 'userConfiguration'
};

export const remove = (key) => localStorage.removeItem(key);

export const set = (key, value) => localStorage.setItem(key, JSON.stringify(value, null, 2));

export const get = (key) => JSON.parse(localStorage.getItem(key));
